import { ROUTE_SEARCH, ROUTE_TASKS } from "@/constants/routes.constants";
import { useLocation, useNavigate } from "react-router";

const useNavigateToTask = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navigateToTask = (taskID: number): void => {
    if (location.pathname.includes(ROUTE_SEARCH)) {
      navigate(`${ROUTE_SEARCH}/${taskID}`);
    } else {
      navigate(`${ROUTE_TASKS}/${taskID}`);
    }
  };

  return { navigateToTask };
};

export default useNavigateToTask;
